import {
    get
} from "@/common/request"

export function GetAboutPageData() {
    return get("about/get")
}